<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            :label="$l('form_label_name_cn') || '中文名称'"
            prop="deCategoryName"
          >
            <el-input
              v-model="formData.deCategoryName"
              maxlength="50"
              :disabled="disabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('form_label_name_en') || '英文名称'"
            prop="deCategoryEnName"
          >
            <el-input
              v-model="formData.deCategoryEnName"
              maxlength="50"
              :disabled="disabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('form_label_status') || '状态'"
            prop="deCategoryStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.deCategoryStatus"
            >
              <el-radio label="Y">{{
                $l("form_radio_valid") || "有效"
              }}</el-radio>
              <el-radio label="N">{{
                $l("form_radio_invalid") || "无效"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <div style="font-size: 14px; color: #606266">
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createDate }}</span
            >
          </div>
          <div style="font-size: 14px; color: #606266">
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      >
      <span>{{ this.$l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          this.$l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          this.$l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";

export default {
  props: {
    disabled: Boolean,
    deCategoryCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        deCategoryCode: "",
        deCategoryName: "",
        deCategoryEnName: "",
        deCategoryStatus: "Y",
        createByName: "",
        createDate: "",
        modifyDate: "",
        modifyByName: "",
      },
      rules: {
        deCategoryName: [
          {
            required: true,
            message: this.$l("form_rule_message_name_cn") || "请输入中文名称",
            trigger: "blur",
          },
          {
            max: 100,
            message:
              this.$l("form_rule_input_length_50") || "长度在50个字符以内",
            trigger: "blur",
          },
        ],
        deCategoryEnName: [
          {
            required: true,
            message: this.$l("form_rule_message_name_en") || "请输入英文名称",
            trigger: "blur",
          },
          {
            max: 30,
            message:
              this.$l("form_rule_input_length_50") || "长度在50个字符以内",
            trigger: "blur",
          },
        ],
        deCategoryStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted(){
    this.getData()
  },
  methods: {
    getData() {
      if (!this.deCategoryCode) return;
      this.$api
        .detailDesignElementsCategoryApi({
          deCategoryCode: this.deCategoryCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    // 保存数据
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$api
        .saveDesignElementsCategoryApi(this.formData)
        .then(() => {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || "保存成功",
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          loadingInstance.close();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
